<cap-content-header>
  <cap-title>
    {{ "sucheNachGrundbuchgeschäften" | translate }}
  </cap-title>
</cap-content-header>

<ul [(activeId)]="searchMode" #nav="ngbNav" class="nav-tabs" ngbNav>
  <li [ngbNavItem]="'searchStandard'">
    <a ngbNavLink>{{ "Standardsuche" | translate }}</a>
    <ng-template id="standard" ngbNavContent>
      <cap-grundbuchgeschaeft-suche-standard></cap-grundbuchgeschaeft-suche-standard>
    </ng-template>
  </li>

  <li [ngbNavItem]="'searchFachId'">
    <a ngbNavLink>{{ "EgbtbidSuche" | translate }}</a>
    <ng-template id="egbtbid" ngbNavContent>
      <cap-grundbuchgeschaeft-suche-egbtbid></cap-grundbuchgeschaeft-suche-egbtbid>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>
